export const getInitialState = (): any => ({
  dataProcessingMergeStatusData: {}
});
